import {
  __TYPE__,
  BirthdayPromotion,
  BonusPointReward,
  CustomerTypePromotion,
  DATE_FORMAT,
  RedeemableDiscounts,
  ReminderPromotion,
} from '../models';
import { DateTimeUtils } from './date-time.utils';

export class RewardUtils {
  // region Reward
  public static transformRewardListForFrontend(
    rewards: BonusPointReward[],
    boId: number
  ): BonusPointReward[] {
    if (!rewards?.length) {
      return rewards;
    }

    rewards.forEach((r) => (r.businessObjectId = boId));

    rewards.sort((r1, r2) => {
      if (r1.bonusPoints < r2.bonusPoints) {
        return -1;
      }
      if (r1.bonusPoints > r2.bonusPoints) {
        return 1;
      }
      return 0;
    });

    return rewards;
  }

  public static transformBonusPointRewardForBackend(
    reward: BonusPointReward
  ): BonusPointReward {
    return {
      ...reward,
      __type__:
        reward?.__type__ || __TYPE__.BASIC_REWARD_BONUS_POINT_BASED_DISCOUNT,
    };
  }

  // endregion

  // region Reminder

  public static transformReminderPromotionForBackend(
    promotion: ReminderPromotion
  ): ReminderPromotion {
    return {
      ...promotion,
      __type__: promotion.__type__ || __TYPE__.BASIC_REMINDER_PROMOTION,
    };
  }

  // endregion

  // region Promotion

  public static transformCustomerTypePromotionForBackend(
    promotion: CustomerTypePromotion
  ): CustomerTypePromotion {
    return {
      ...promotion,
      __type__:
        promotion.__type__ || __TYPE__.BASIC_CUSTOMER_TYPE_BASED_PROMOTION,
      validFrom: DateTimeUtils.formatDateTimeToString(
        DateTimeUtils.getBeginOfDate(promotion.validFromAsDate),
        DATE_FORMAT.DATE_FORMAT_BACKEND
      ),
      validUntil: DateTimeUtils.formatDateTimeToString(
        DateTimeUtils.getEndOfDate(promotion.validUntilAsDate),
        DATE_FORMAT.DATE_FORMAT_BACKEND
      ),
      activationDate: DateTimeUtils.formatDateTimeToString(
        DateTimeUtils.getBeginOfDate(promotion.activationDateAsDate),
        DATE_FORMAT.DATE_FORMAT_BACKEND
      ),
      customerTypesCSV: promotion.customerTypes?.join(','),
    };
  }

  public static transformCustomerTypePromotionListForFrontend(
    promotions: CustomerTypePromotion[]
  ): CustomerTypePromotion[] {
    if (!promotions?.length) {
      return promotions;
    }

    const transformedList = promotions?.map((p) =>
      this.transformCustomerTypePromotionForFrontend(p)
    );
    transformedList.sort((p1, p2) => {
      if (p1.validUntil < p2.validUntil) {
        return 1;
      }

      if (p1.validUntil > p2.validUntil) {
        return -1;
      }

      if (p1.validFrom < p2.validFrom) {
        return 1;
      }

      if (p1.validFrom > p2.validFrom) {
        return -1;
      }

      if (p1.activationDate < p2.activationDate) {
        return 1;
      }

      if (p1.activationDate > p2.activationDate) {
        return -1;
      }

      return 0;
    });

    return transformedList;
  }

  public static transformCustomerTypePromotionForFrontend(
    promotion: CustomerTypePromotion
  ): CustomerTypePromotion {
    if (!promotion) {
      return promotion;
    }

    return {
      ...promotion,
      __type__:
        promotion.__type__ || __TYPE__.BASIC_CUSTOMER_TYPE_BASED_PROMOTION,
      validFromAsDate: DateTimeUtils.parseStringToDate(promotion.validFrom),
      validUntilAsDate: DateTimeUtils.parseStringToDate(promotion.validUntil),
      activationDateAsDate: DateTimeUtils.parseStringToDate(
        promotion.activationDate
      ),
    };
  }
  // endregion

  // region Birthday

  public static transformBirthdayPromotionForBackend(
    birthdayPromotion: BirthdayPromotion
  ): BirthdayPromotion {
    return {
      ...birthdayPromotion,
      __type__: birthdayPromotion.__type__ || __TYPE__.BASIC_BIRTHDAY_PROMOTION,
    };
  }

  // endregion

  // region RedeemableDiscounts

  public static transformRedeemableDiscountsForFrontend(
    discounts: RedeemableDiscounts
  ): RedeemableDiscounts {
    if (!discounts) {
      return null;
    }

    const promotionDiscounts = discounts.promotionDiscounts || [];
    promotionDiscounts.sort((a, b) => {
      if (a.percentage && !b.percentage) {
        return -1;
      }

      if (!a.percentage && b.percentage) {
        return 1;
      }

      return a.value - b.value;
    });

    const bonusPointBasedDiscounts = discounts.bonusPointBasedDiscounts || [];
    bonusPointBasedDiscounts.sort((a, b) => a.bonusPoints - b.bonusPoints);

    return {
      ...discounts,
      promotionDiscounts,
      bonusPointBasedDiscounts,
    };
  }

  // endregion
}
